import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots",
  "use": "dots-usage",
  "viewBox": "0 0 17 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 4\" id=\"dots\"><path d=\"M3.367 1.538a1.538 1.538 0 11-3.077 0 1.538 1.538 0 013.077 0zM10.136 1.538a1.538 1.538 0 11-3.077 0 1.538 1.538 0 013.077 0zM16.29 1.538a1.538 1.538 0 11-3.077 0 1.538 1.538 0 013.077 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol